import { Dispatch, SetStateAction } from 'react'

// locals
import { IFavoriteCampusServices, TCampusServiceSubType, TCampusServiceType } from 'types/FavoritesType'
import CoiffeurService from 'service/CoiffeurService'
import HealthService from 'service/HealthService'
import GymService from 'service/GymService'
import LactationService from 'service/LactationService'
import MeetingRoomService from 'service/MeetingRoomService'

const serviceFn = {
  1: HealthService.removeDoctorFavorite,
  2: CoiffeurService.removeCoiffeurFavorite,
  3: GymService.removeGymSaloonFavorite,
  4: LactationService.removeLactationRoomFavorite,
  6: MeetingRoomService.removeMeetingRoomFavorite,
}

const serviceSubFn = {
  1: GymService.removeGymSaloonFavorite,
  2: GymService.removeGymTrainerFavorite,
  3: GymService.removeGymGroupLessonFavorite,
}

export default function useListActions(setList: Dispatch<SetStateAction<[] | IFavoriteCampusServices[]>>) {
  const handleRemoveFavorite = (type: TCampusServiceType, subType: TCampusServiceSubType, id: number) => () => {
    if (type !== 3) {
      serviceFn[type](id)
        .then((_res) => setList((prev) => prev.filter((pr) => pr.id !== id)))
        .catch((err) => console.log(err))
    } else if (subType !== 0) {
      serviceSubFn[subType](id)
        .then((_res) => setList((prev) => prev.filter((pr) => pr.id !== id)))
        .catch((err) => console.log(err))
    } else return
  }

  return { handleRemoveFavorite }
}
